<template>
  <div class="text-center">
    <hr />
    <b-img :src="printer" alt="today"></b-img>
    <a href="https://www.mypay.sk/vypisy/" target="new" class="text-14 mb-0 text-primary semi-bold">
      {{ $t("print-receipt") }}
    </a>
  </div>
</template>

<script>
import printer from "../../assets/icons/printer.svg"

export default {
  data() {
    return {
      printer: printer
    };
  }
};
</script>
  
<style scoped lang="scss">
  #ecasenkaDetail hr {
    margin: 0.5rem;
  }
</style>